<template>
	<div v-if="0" class="tutorial">
		<div class="overlay" @click="next"></div>
		<div class="bottom">
			<div class="control_box d_flex align_items_center justify_between">
				<a @click="prev"><span class="icon tutorial_left_arrow"></span></a>
				<div class="bottom_content_wrap">
					<div class="d_flex align_items_center mr_10">
						<input type="checkbox" id="off" class="mr_10" v-model="check" />
						<label for="off">{{ $t('button.do_not_look') }}</label>
					</div>
					<a class="btn_close" @click="closeTutorial">{{
						$t('button.close')
					}}</a>
				</div>
				<a @click="next"><span class="icon tutorial_right_arrow"></span></a>
			</div>
		</div>
	</div>
</template>

<script>
import { stepCollection } from '@/common/tutorial';
import Shepherd from 'shepherd.js';
import Cookies from 'js-cookie';

export default {
	name: 'Tutorial',
	props: {},
	data() {
		return {
			check: false,
			tour: null,
		};
	},
	mounted() {
		this.tutorialHandler();
	},
	beforeUnmount() {
		this.closeTutorial();
	},
	computed: {
		stepCollection,
	},
	methods: {
		tourInit(stepKey) {
			const tour = new Shepherd.Tour({
				defaultStepOptions: {
					scrollTo: { behavior: 'smooth', block: 'center' },
					canClickTarget: false,
					classes: 'tutorial_bubble',
				},
				keyboardNavigation: false,
				exitOnEsc: false,
			});
			tour.addSteps(this.stepCollection[stepKey]);
			return tour;
		},
		tutorialHandler() {
			return;
			// eslint-disable-next-line no-unreachable
			this.tour = this.tourInit(this.$route.name);
			if (this.tour.steps.length === 0) {
				this.closeTutorial();
			}
			this.tour.start();
			this.tour.on('complete', () => {
				this.$emit('close');
			});
		},
		closeTutorial() {
			return;
			// eslint-disable-next-line no-unreachable
			if (this.check) {
				this.setCookie();
			}
			this.tour.cancel();
			this.$emit('close');
		},
		setCookie() {
			Cookies.set(this.$route.name + '_tutorial', this.check);
		},
		prev() {
			this.checkElement('prev');
			this.tour.back();
		},
		next() {
			this.checkElement('next');
			this.tour.next();
		},
		checkElement(type) {
			const currentIndex = this.tour.steps.findIndex(item => {
				return item.id === this.tour.getCurrentStep().id;
			});
			const nextStep =
				type === 'next'
					? this.tour.steps[currentIndex + 1]
					: this.tour.steps[currentIndex - 1];
			if (nextStep) {
				const checkElement = document.querySelector('#' + nextStep.id);
				if (!checkElement) {
					this.tour.removeStep(nextStep.id);
				}
			}
		},
	},
};
</script>
